import { Row, Spinner } from "@masterteam/mt-design-react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";

import Modal from "../Modal";
import Reports from "../Report";
import AsyncSvg from "../AsyncSvg";
import Programs from "../Programs";
import KPIWizard from "../KPIWizard";
import Navigator from "../Navigator";
import TaskCenter from "../TaskCenter";
import Initiatives from "../Initiatives";
import KPIsDashboard from "../KPIsDashboard";
import Calendar from "../TaskCenter/Calendar";
import SectorsDashboard from "../SectorsDashboard";
import AddNewInitiative from "../AddNewInitiative";
import AttributeDetails from "../AttributeDetails";
import InitiativeDetails from "../InitiativeDetails";
import StrategyDashboard from "../StrategyDashboard";
import KPIDetails from "../../components/KPIDetails";
import CreateProgramForm from "../CreateProgramForm";
import StrategyMap from "../../components/StrategyMap";
import Delegations from "../../components/Delegations";
import InitiativesDetails from "../InitiativesDetails";
import KPIChangeDetails from "../KPIChangeDetails";
import KPIChangeParameters from "../KPIChangeParameters";
import KPIChangeActualValues from "../KPIChangeActualValues";
import ErrorBoundary from "../../components/ErrorBoundary";
import KPIChangeMeasurements from "../KPIChangeMeasurements";
import ObjectiveDetails from "../../components/ObjectiveDetails";
import LevelTwoObjectivesDashboard from "../LevelTwoObjectivesDashboard";
import DashboardObjectiveDetails from "../KPIsDashboard/ObjectiveDetails";

import { getStrategies } from "../../reducers/strategy";
import { getTasks } from "../../reducers/taskCenter";

import { ReactComponent as TaskCenterIcon } from "../../assets/images/task-center.svg";
import { ReactComponent as KPIsDashboardIcon } from "../../assets/images/bar-chart.svg";
import { ReactComponent as DashboardsIcon } from "../../assets/images/bar-chart.svg";
import { ReactComponent as InitiativesIcon } from "../../assets/images/initiative-icon.svg";
import { ReactComponent as ProgramsIcon } from "../../assets/images/programs-icon.svg";
import { ReactComponent as ReportsIcon } from "../../assets/images/report-news.svg";
import { ReactComponent as StrategicIcon } from "../../assets/images/strategic-strategy.svg";
import { ReactComponent as SupportiveIcon } from "../../assets/images/supportive-strategy.svg";

import "./style.scss";

const staticRoutes = [
  {
    path: "/splus/kpi-details/:id",
    name: "KPI Details",
    component: KPIDetails,
  },
  {
    path: "/splus/add-new-initiative/:id",
    name: "Add New Initiative",
    component: AddNewInitiative,
  },
  {
    path: "/splus/add-new-initiative",
    name: "Add New Initiative",
    key: "CIF",
    component: AddNewInitiative,
  },
  {
    path: "/splus/objective-details/:id/initiatives/:id",
    name: "StrategyMap",
    component: InitiativesDetails,
  },
  {
    path: "/splus/objective-details/:id",
    name: "StrategyMap",
    component: ObjectiveDetails,
  },

  {
    path: "/splus/attribute-details/:id",
    name: "StrategyMap",
    component: AttributeDetails,
  },
  {
    path: "/splus/delegations",
    name: "Delegations",
    key: "DE",
    component: Delegations,
  },
  {
    path: "/splus/initiatives",
    name: "common.initiatives",
    icon: <InitiativesIcon className="tab-icon" />,
    showInNav: true,
    key: "IC",
    component: Initiatives,
  },
  {
    path: "/splus/programs",
    name: "common.programs",
    icon: <ProgramsIcon className="tab-icon" />,
    showInNav: true,
    key: "PC",
    component: Programs,
  },
  {
    path: "/splus/initiative-details/:id",
    name: "initiative-details",
    component: InitiativeDetails,
  },
  {
    path: "/splus/task-center/calendar",
    name: "task-center-calendar",
    showInNav: false,
    component: Calendar,
  },
  {
    path: "/splus/task-center",
    name: "task-center",
    icon: <TaskCenterIcon className="tab-icon" />,
    showInNav: true,
    isTaskCenter: true,
    key: "TC",
    component: TaskCenter,
  },
  {
    path: "/splus/kpis-dashboard/objective-details/:id",
    name: "kpis-dashboard",
    component: DashboardObjectiveDetails,
  },
  {
    path: "/splus/kpis-dashboard",
    name: "kpis-dashboard",
    key: "KD",
    icon: <KPIsDashboardIcon className="tab-icon" />,
    showInNav: true,
    component: KPIsDashboard,
  },
  {
    name: "common.dashboards",
    key: "Dashboard",
    path: "/splus/dashboards/",
    icon: <DashboardsIcon className="tab-icon" />,
    showInNav: true,
    subItems: [
      {
        name: "dashboards.strategy-performance",
        path: "/splus/strategy-performance-dashboard",
      },
      {
        name: "dashboards.sectors-performance",
        path: "/splus/sectors-performance-dashboard",
      },
      {
        name: "dashboards.level-two-objectives-performance",
        path: "/splus/level-two-objectives-performance-dashboard",
      },
    ],
  },
  {
    path: "/splus/strategy-performance-dashboard",
    name: "strategy-performance",
    component: StrategyDashboard,
  },
  {
    path: "/splus/sectors-performance-dashboard",
    name: "sectors-performance",
    component: SectorsDashboard,
  },
  {
    path: "/splus/level-two-objectives-performance-dashboard",
    name: "level-two-objectives-performance",
    component: LevelTwoObjectivesDashboard,
  },
  {
    path: "/splus/reports",
    name: "common.reports",
    key: "RP",
    icon: <ReportsIcon className="tab-icon" />,
    showInNav: true,
    component: Reports,
  },
  {
    path: "/splus/change-kpi-details/:id",
    name: "KPI Change Details",
    component: KPIChangeDetails,
  },
  {
    path: "/splus/change-kpi-details",
    name: "KPI Change Details",
    component: KPIChangeDetails,
  },
  {
    path: "/splus/change-kpi-measurements/:id",
    name: "KPI Change Measurements",
    component: KPIChangeMeasurements,
  },
  {
    path: "/splus/change-kpi-measurements",
    name: "KPI Change Measurements",
    component: KPIChangeMeasurements,
  },
  {
    path: "/splus/change-kpi-actual-values/:id",
    name: "KPI Change Actual Values",
    component: KPIChangeActualValues,
  },
  {
    path: "/splus/change-kpi-actual-values",
    name: "KPI Change Actual Values",
    component: KPIChangeActualValues,
  },
  {
    path: "/splus/change-kpi-parameters/:id",
    name: "KPI Change Parameters",
    component: KPIChangeParameters,
  },
  {
    path: "/splus/change-kpi-parameters",
    name: "KPI Change Parameters",
    component: KPIChangeParameters,
  },
];

const initialModalState = {
  isOpen: false,
  data: null,
};

function MainLayout() {
  const dispatch = useDispatch();
  const [programFormModal, setProgramFormModal] = useState(initialModalState);
  const [kpiModal, setKpiModal] = useState(initialModalState);
  const [theme, language, user] = useSelector((store) => [
    store.theme,
    store.language,
    store.user,
  ]);

  const [allowedScreens, forms, { strategies, isLoading }] = useSelector(
    ({ user, strategy }) => [user.user.screens, user.user.forms, strategy]
  );

  useEffect(() => {
    dispatch(getTasks());

    dispatch(getStrategies());
  }, [user]);

  const routes = [
    {
      path: "/splus/strategy-map/:id",
      name: "strategy-map.strategic-plans",
      icon: <StrategicIcon className="tab-icon" width={25} />,
      showInNav: true,
      key: "BSC",
      component: StrategyMap,
      subItems: [
        ...strategies
          .filter((e) => +e.StrategyType === 1)
          .map((item) => ({
            path: `/splus/strategy-map/${item.ID}`,
            arabicName: item.ArabicName,
            englishName: item.EnglishName,
            icon: item?.Attachment ? (
              <AsyncSvg className="tab-icon" attachment={item.Attachment} />
            ) : (
              <StrategicIcon className="tab-icon" />
            ),
          })),
      ],
    },
    {
      path: "/splus/strategy-map/:id",
      name: "strategy-map.supportive-plans",
      icon: <SupportiveIcon className="tab-icon" />,
      showInNav: true,
      key: "BSC",
      component: StrategyMap,
      subItems: [
        ...strategies
          .filter((e) => +e.StrategyType === 2)
          .map((item) => ({
            path: `/splus/strategy-map/${item.ID}`,
            arabicName: item.ArabicName,
            englishName: item.EnglishName,
            icon: item?.Attachment ? (
              <AsyncSvg className="tab-icon" attachment={item.Attachment} />
            ) : (
              <SupportiveIcon className="tab-icon" />
            ),
          })),
      ],
    },
    ...staticRoutes,
  ];

  return (
    <div className="app">
      <ErrorBoundary>
        {isLoading ? (
          <Row justify="center" align="center" style={{ height: "100%" }}>
            <Spinner size="large" />
          </Row>
        ) : (
          <>
            <Navigator
              getNavigatorItems={() => {
                return routes.filter((item) => item?.showInNav);
              }}
            />

            {/* <MainDropDown
              theme={theme}
              locale={language.locale}
              setProgramFormModal={setProgramFormModal}
              setKpiModal={setKpiModal}
            /> */}

            <div className="main-layout-content-container">
              <Switch>
                {routes.map(
                  ({ path, name, component, key }) =>
                    (!key ||
                      allowedScreens?.includes(key) ||
                      forms?.includes(key)) && (
                      <Route
                        path={path}
                        name={name}
                        component={component}
                        key={name}
                      />
                    )
                )}

                <Redirect
                  from="/"
                  to={`/splus/strategy-map/${strategies?.[0]?.ID || ""}`}
                />
              </Switch>
            </div>

            {programFormModal.isOpen && (
              <CreateProgramForm
                data={programFormModal.data}
                closeModal={() => setProgramFormModal(initialModalState)}
              />
            )}

            {kpiModal?.isOpen && (
              <Modal isOpen={kpiModal?.isOpen}>
                <KPIWizard
                  isAddKpiProcess
                  bindKPI={() => {}}
                  editData={kpiModal.data}
                  modeSaveOrUpdate={!kpiModal.data}
                  closeModal={() => setKpiModal(initialModalState)}
                />
              </Modal>
            )}
          </>
        )}
      </ErrorBoundary>
    </div>
  );
}

export default MainLayout;
